export const MYFC_INITIAL_COORD = naver?.maps
  ? new naver.maps.LatLng(37.5079436, 127.0574963)
  : (null as unknown as naver.maps.LatLng);

export const UPLUSE_INITIAL_COORD = naver?.maps
  ? new naver.maps.LatLng(37.5237879629473, 126.963508875989)
  : (null as unknown as naver.maps.LatLng);
